import { Agent, Channel, MerchantStructure, User, UserType } from '@nemuru-eng/js-api-client';

import { getSelectedUserTypeAndRole } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/components/ChangeUser/utils/getSelectedUserTypeAndRole';
import MerchantStructureEntity from '@/entities/MerchantStructureEntity';
import { UserInStructure } from '@/types/UserInStructure';

interface UseStructureUserProps {
  selectedUser: User | UserInStructure;
  merchantStructure: MerchantStructure;
}

export const useStructureUser = ({ selectedUser, merchantStructure }: UseStructureUserProps) => {
  const newSelectedUser = selectedUser as User;

  if (!('userType' in selectedUser)) {
    const { type } = getSelectedUserTypeAndRole(selectedUser);
    newSelectedUser.userType = type;
    if (type === UserType.AGENT) {
      newSelectedUser.userId = selectedUser.id;
    }
  }

  let selectedUserChannel: Channel | undefined;
  let selectedUserAgent: Agent | undefined;

  if (newSelectedUser.userType === UserType.AGENT) {
    const merchantStructureEntity = MerchantStructureEntity.create({
      merchantStructure,
      agentId: newSelectedUser.userId,
    });
    selectedUserChannel = merchantStructureEntity.getChannel();
    selectedUserAgent = merchantStructureEntity.getAgent();
  }

  if (newSelectedUser.userType === UserType.CHANNEL) {
    selectedUserChannel = merchantStructure.merchant.channels.find(
      (channel) => channel.id === newSelectedUser.userId || channel.id === newSelectedUser.id,
    );
  }

  return {
    selectedUserType: newSelectedUser.userType,
    selectedUserMerchant: merchantStructure.merchant.businessName,
    selectedUserChannel,
    selectedUserAgent,
  };
};
